<template>
  <div class="box">
    <submit v-if="!showSuccess" @success="success" />
    <success v-else />
    <alert :showModal.sync="showAlert">{{ alertMessage }}</alert>
  </div>
</template>


<script>
/* eslint-disable */
import success from './success.vue'
import submit from './submit.vue'
import utils from '@/Utils/utils.js'
import alert from '@/components/alert/alert'
export default {
  data() {
    return {
      showAlert: false,
      showSuccess: false,
      alertMessage: ''
    }
  },
  components: { success, submit, alert },
  mounted() {},
  methods: {
    success() {
      this.showSuccess = true
    }
  }
}
</script>

<style scoped>
.box {
  width: 100vw;
  height: 100vh;
}
</style>


// WEBPACK FOOTER //
// index.vue?e7d4a838